import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useProfile } from '../../hooks/useUserData';

// Redirects to the dashboard overview until the user has started selling
// (profiles.is_seller). Wraps the seller-only dashboard routes.
export default function SellerOnlyRoute({ children }: { children: React.ReactNode }) {
  const { userId, isLoading: authLoading } = useAuth();
  const { data: profile, isLoading: profileLoading } = useProfile(userId);

  // Wait until auth AND the profile are resolved before deciding. While userId
  // is still loading, useProfile is disabled (isLoading is false in v5), so
  // without the `!userId` guard we'd redirect/flash off the seller page on every
  // mount and then render it again once userId arrives → visible flicker.
  if (authLoading || !userId || profileLoading) return null;
  if (!profile?.is_seller) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
